/**
 * SELECT OPTIONS RISKS
 *
 * @version 0.1
 */
import React from 'react';
import { injectIntl } from 'react-intl';

import { LANGUAGE_SELECT_OPTIONS } from './../../constants';

function SelectOptionsLanguage({language, onChange, intl}) {

    let languages = Object.keys(LANGUAGE_SELECT_OPTIONS);

    return (
        <select className="notranslate language-select"
                value={language}
                onChange={onChange}
                title={intl.formatMessage({id: LANGUAGE_SELECT_OPTIONS[language]})}>

            {
                languages.map((language) => (
                    <option key={'language-option-' + language} value={language}>
                        {intl.formatMessage({id: LANGUAGE_SELECT_OPTIONS[language]})}
                    </option>
                ))
            }

        </select>
    );

}

export default injectIntl(SelectOptionsLanguage);


// WEBPACK FOOTER //
// ./src/scripts/reusable/Dropdowns/SelectOptionsLanguage.jsx